<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .paragraph-text
        background: $color-gray-light
        margin-top: 6rem

        &__container
            margin-top: 6rem
            +container
            +media("<=desktop")
                padding: 6rem
            +media("<=tablet")
                padding: 3rem
            +media("<phone")
                padding: 3rem 2rem

            .basic-html
                padding-left: 7rem
                padding-right: 7rem

            .title--4
                margin-bottom: 1rem

            .button
                margin-top: 2rem
                width: 12rem
                +media("<=phone")
                    width: 100%
                    margin-top: 1rem
            p
                line-height: 1.8!important

</style>


<script>
    import $ from 'jquery'

    export default {

        data() {
            return {
                buttonLegend: "",
                mode: "close"
            }
        },

        mounted() {
            if ( $(this.$el).find('.button').length )
                this.toggle();
        },

        methods: {

            toggle: function() {
                let $items = $(this.$el).find('.paragraph-text__item');
                let $button = $(this.$el).find('.button');

                if ( this.mode === "open" ) {
                    $items.show();
                    this.mode = "close";
                    this.buttonLegend = $button.attr('minus');
                } else {
                    $items.hide().eq(0).show();
                    this.mode = "open";
                    this.buttonLegend = $button.attr('plus');
                }
            }

        }

    }


</script>